module.exports = __webpack_public_path__ + "20230117/img/slide1_title.d579644.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide1_title.png
// module id = Jp3U
// module chunks = 1